var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightBlack = function SvgArrowRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    stroke: "#121212",
    strokeWidth: 0.6,
    d: "M13.53 5.53a.75.75 0 0 0-1.06 1.06l4.62 4.62H4.75a.75.75 0 0 0 0 1.5h12.32l-4.608 4.697a.753.753 0 0 0 1.07 1.06l5.62-5.618a1.2 1.2 0 0 0 0-1.697z"
  })));
};
export default SvgArrowRightBlack;